//auto-generated from country_codes.json, do not modify.
export default [
  {
    'id': 'AF',
    'text': 'Afghanistan',
    'dial_code': '93'
  },
  {
    'id': 'AL',
    'text': 'Albania',
    'dial_code': '355'
  },
  {
    'id': 'DZ',
    'text': 'Algeria',
    'dial_code': '213'
  },
  {
    'id': 'AS',
    'text': 'AmericanSamoa',
    'dial_code': '1684'
  },
  {
    'id': 'AD',
    'text': 'Andorra',
    'dial_code': '376'
  },
  {
    'id': 'AO',
    'text': 'Angola',
    'dial_code': '244'
  },
  {
    'id': 'AI',
    'text': 'Anguilla',
    'dial_code': '1264'
  },
  {
    'id': 'AG',
    'text': 'Antigua and Barbuda',
    'dial_code': '1268'
  },
  {
    'id': 'AR',
    'text': 'Argentina',
    'dial_code': '54'
  },
  {
    'id': 'AM',
    'text': 'Armenia',
    'dial_code': '374'
  },
  {
    'id': 'AW',
    'text': 'Aruba',
    'dial_code': '297'
  },
  {
    'id': 'AU',
    'text': 'Australia',
    'dial_code': '61'
  },
  {
    'id': 'AT',
    'text': 'Austria',
    'dial_code': '43'
  },
  {
    'id': 'AZ',
    'text': 'Azerbaijan',
    'dial_code': '994'
  },
  {
    'id': 'BS',
    'text': 'Bahamas',
    'dial_code': '1242'
  },
  {
    'id': 'BH',
    'text': 'Bahrain',
    'dial_code': '973'
  },
  {
    'id': 'BD',
    'text': 'Bangladesh',
    'dial_code': '880'
  },
  {
    'id': 'BB',
    'text': 'Barbados',
    'dial_code': '1246'
  },
  {
    'id': 'BY',
    'text': 'Belarus',
    'dial_code': '375'
  },
  {
    'id': 'BE',
    'text': 'Belgium',
    'dial_code': '32'
  },
  {
    'id': 'BZ',
    'text': 'Belize',
    'dial_code': '501'
  },
  {
    'id': 'BJ',
    'text': 'Benin',
    'dial_code': '229'
  },
  {
    'id': 'BM',
    'text': 'Bermuda',
    'dial_code': '1441'
  },
  {
    'id': 'BT',
    'text': 'Bhutan',
    'dial_code': '975'
  },
  {
    'id': 'BA',
    'text': 'Bosnia and Herzegovina',
    'dial_code': '387'
  },
  {
    'id': 'BW',
    'text': 'Botswana',
    'dial_code': '267'
  },
  {
    'id': 'BR',
    'text': 'Brazil',
    'dial_code': '55'
  },
  {
    'id': 'IO',
    'text': 'British Indian Ocean Territory',
    'dial_code': '246'
  },
  {
    'id': 'BG',
    'text': 'Bulgaria',
    'dial_code': '359'
  },
  {
    'id': 'BF',
    'text': 'Burkina Faso',
    'dial_code': '226'
  },
  {
    'id': 'BI',
    'text': 'Burundi',
    'dial_code': '257'
  },
  {
    'id': 'KH',
    'text': 'Cambodia',
    'dial_code': '855'
  },
  {
    'id': 'CM',
    'text': 'Cameroon',
    'dial_code': '237'
  },
  {
    'id': 'CV',
    'text': 'Cape Verde',
    'dial_code': '238'
  },
  {
    'id': 'KY',
    'text': 'Cayman Islands',
    'dial_code': '345'
  },
  {
    'id': 'CF',
    'text': 'Central African Republic',
    'dial_code': '236'
  },
  {
    'id': 'TD',
    'text': 'Chad',
    'dial_code': '235'
  },
  {
    'id': 'CL',
    'text': 'Chile',
    'dial_code': '56'
  },
  {
    'id': 'CN',
    'text': 'China',
    'dial_code': '86'
  },
  {
    'id': 'CX',
    'text': 'Christmas Island',
    'dial_code': '61'
  },
  {
    'id': 'CO',
    'text': 'Colombia',
    'dial_code': '57'
  },
  {
    'id': 'KM',
    'text': 'Comoros',
    'dial_code': '269'
  },
  {
    'id': 'CG',
    'text': 'Congo',
    'dial_code': '242'
  },
  {
    'id': 'CK',
    'text': 'Cook Islands',
    'dial_code': '682'
  },
  {
    'id': 'CR',
    'text': 'Costa Rica',
    'dial_code': '506'
  },
  {
    'id': 'HR',
    'text': 'Croatia',
    'dial_code': '385'
  },
  {
    'id': 'CU',
    'text': 'Cuba',
    'dial_code': '53'
  },
  {
    'id': 'CY',
    'text': 'Cyprus',
    'dial_code': '357'
  },
  {
    'id': 'CZ',
    'text': 'Czech Republic',
    'dial_code': '420'
  },
  {
    'id': 'DK',
    'text': 'Denmark',
    'dial_code': '45'
  },
  {
    'id': 'DJ',
    'text': 'Djibouti',
    'dial_code': '253'
  },
  {
    'id': 'DM',
    'text': 'Dominica',
    'dial_code': '1767'
  },
  {
    'id': 'DO',
    'text': 'Dominican Republic',
    'dial_code': '1809'
  },
  {
    'id': 'EC',
    'text': 'Ecuador',
    'dial_code': '593'
  },
  {
    'id': 'EG',
    'text': 'Egypt',
    'dial_code': '20'
  },
  {
    'id': 'SV',
    'text': 'El Salvador',
    'dial_code': '503'
  },
  {
    'id': 'GQ',
    'text': 'Equatorial Guinea',
    'dial_code': '240'
  },
  {
    'id': 'ER',
    'text': 'Eritrea',
    'dial_code': '291'
  },
  {
    'id': 'EE',
    'text': 'Estonia',
    'dial_code': '372'
  },
  {
    'id': 'ET',
    'text': 'Ethiopia',
    'dial_code': '251'
  },
  {
    'id': 'FO',
    'text': 'Faroe Islands',
    'dial_code': '298'
  },
  {
    'id': 'FJ',
    'text': 'Fiji',
    'dial_code': '679'
  },
  {
    'id': 'FI',
    'text': 'Finland',
    'dial_code': '358'
  },
  {
    'id': 'FR',
    'text': 'France',
    'dial_code': '33'
  },
  {
    'id': 'GF',
    'text': 'French Guiana',
    'dial_code': '594'
  },
  {
    'id': 'PF',
    'text': 'French Polynesia',
    'dial_code': '689'
  },
  {
    'id': 'GA',
    'text': 'Gabon',
    'dial_code': '241'
  },
  {
    'id': 'GM',
    'text': 'Gambia',
    'dial_code': '220'
  },
  {
    'id': 'GE',
    'text': 'Georgia',
    'dial_code': '995'
  },
  {
    'id': 'DE',
    'text': 'Germany',
    'dial_code': '49'
  },
  {
    'id': 'GH',
    'text': 'Ghana',
    'dial_code': '233'
  },
  {
    'id': 'GI',
    'text': 'Gibraltar',
    'dial_code': '350'
  },
  {
    'id': 'GR',
    'text': 'Greece',
    'dial_code': '30'
  },
  {
    'id': 'GL',
    'text': 'Greenland',
    'dial_code': '299'
  },
  {
    'id': 'GD',
    'text': 'Grenada',
    'dial_code': '1473'
  },
  {
    'id': 'GP',
    'text': 'Guadeloupe',
    'dial_code': '590'
  },
  {
    'id': 'GU',
    'text': 'Guam',
    'dial_code': '1671'
  },
  {
    'id': 'GT',
    'text': 'Guatemala',
    'dial_code': '502'
  },
  {
    'id': 'GN',
    'text': 'Guinea',
    'dial_code': '224'
  },
  {
    'id': 'GW',
    'text': 'Guinea Bissau',
    'dial_code': '245'
  },
  {
    'id': 'GY',
    'text': 'Guyana',
    'dial_code': '592'
  },
  {
    'id': 'HT',
    'text': 'Haiti',
    'dial_code': '509'
  },
  {
    'id': 'HN',
    'text': 'Honduras',
    'dial_code': '504'
  },
  {
    'id': 'HU',
    'text': 'Hungary',
    'dial_code': '36'
  },
  {
    'id': 'IS',
    'text': 'Iceland',
    'dial_code': '354'
  },
  {
    'id': 'IN',
    'text': 'India',
    'dial_code': '91'
  },
  {
    'id': 'ID',
    'text': 'Indonesia',
    'dial_code': '62'
  },
  {
    'id': 'IQ',
    'text': 'Iraq',
    'dial_code': '964'
  },
  {
    'id': 'IE',
    'text': 'Ireland',
    'dial_code': '353'
  },
  {
    'id': 'IL',
    'text': 'Israel',
    'dial_code': '972'
  },
  {
    'id': 'IT',
    'text': 'Italy',
    'dial_code': '39'
  },
  {
    'id': 'JM',
    'text': 'Jamaica',
    'dial_code': '1876'
  },
  {
    'id': 'JP',
    'text': 'Japan',
    'dial_code': '81'
  },
  {
    'id': 'JO',
    'text': 'Jordan',
    'dial_code': '962'
  },
  {
    'id': 'KZ',
    'text': 'Kazakhstan',
    'dial_code': '77'
  },
  {
    'id': 'KE',
    'text': 'Kenya',
    'dial_code': '254'
  },
  {
    'id': 'KI',
    'text': 'Kiribati',
    'dial_code': '686'
  },
  {
    'id': 'KW',
    'text': 'Kuwait',
    'dial_code': '965'
  },
  {
    'id': 'KG',
    'text': 'Kyrgyzstan',
    'dial_code': '996'
  },
  {
    'id': 'LV',
    'text': 'Latvia',
    'dial_code': '371'
  },
  {
    'id': 'LB',
    'text': 'Lebanon',
    'dial_code': '961'
  },
  {
    'id': 'LS',
    'text': 'Lesotho',
    'dial_code': '266'
  },
  {
    'id': 'LR',
    'text': 'Liberia',
    'dial_code': '231'
  },
  {
    'id': 'LI',
    'text': 'Liechtenstein',
    'dial_code': '423'
  },
  {
    'id': 'LT',
    'text': 'Lithuania',
    'dial_code': '370'
  },
  {
    'id': 'LU',
    'text': 'Luxembourg',
    'dial_code': '352'
  },
  {
    'id': 'MG',
    'text': 'Madagascar',
    'dial_code': '261'
  },
  {
    'id': 'MW',
    'text': 'Malawi',
    'dial_code': '265'
  },
  {
    'id': 'MY',
    'text': 'Malaysia',
    'dial_code': '60'
  },
  {
    'id': 'MV',
    'text': 'Maldives',
    'dial_code': '960'
  },
  {
    'id': 'ML',
    'text': 'Mali',
    'dial_code': '223'
  },
  {
    'id': 'MT',
    'text': 'Malta',
    'dial_code': '356'
  },
  {
    'id': 'MH',
    'text': 'Marshall Islands',
    'dial_code': '692'
  },
  {
    'id': 'MQ',
    'text': 'Martinique',
    'dial_code': '596'
  },
  {
    'id': 'MR',
    'text': 'Mauritania',
    'dial_code': '222'
  },
  {
    'id': 'MU',
    'text': 'Mauritius',
    'dial_code': '230'
  },
  {
    'id': 'YT',
    'text': 'Mayotte',
    'dial_code': '262'
  },
  {
    'id': 'MX',
    'text': 'Mexico',
    'dial_code': '52'
  },
  {
    'id': 'MC',
    'text': 'Monaco',
    'dial_code': '377'
  },
  {
    'id': 'MN',
    'text': 'Mongolia',
    'dial_code': '976'
  },
  {
    'id': 'ME',
    'text': 'Montenegro',
    'dial_code': '382'
  },
  {
    'id': 'MS',
    'text': 'Montserrat',
    'dial_code': '1664'
  },
  {
    'id': 'MA',
    'text': 'Morocco',
    'dial_code': '212'
  },
  {
    'id': 'MM',
    'text': 'Myanmar',
    'dial_code': '95'
  },
  {
    'id': 'NA',
    'text': 'Namibia',
    'dial_code': '264'
  },
  {
    'id': 'NR',
    'text': 'Nauru',
    'dial_code': '674'
  },
  {
    'id': 'NP',
    'text': 'Nepal',
    'dial_code': '977'
  },
  {
    'id': 'NL',
    'text': 'Netherlands',
    'dial_code': '31'
  },
  {
    'id': 'AN',
    'text': 'Netherlands Antilles',
    'dial_code': '599'
  },
  {
    'id': 'NC',
    'text': 'New Caledonia',
    'dial_code': '687'
  },
  {
    'id': 'NZ',
    'text': 'New Zealand',
    'dial_code': '64'
  },
  {
    'id': 'NI',
    'text': 'Nicaragua',
    'dial_code': '505'
  },
  {
    'id': 'NE',
    'text': 'Niger',
    'dial_code': '227'
  },
  {
    'id': 'NG',
    'text': 'Nigeria',
    'dial_code': '234'
  },
  {
    'id': 'NU',
    'text': 'Niue',
    'dial_code': '683'
  },
  {
    'id': 'NF',
    'text': 'Norfolk Island',
    'dial_code': '672'
  },
  {
    'id': 'MP',
    'text': 'Northern Mariana Islands',
    'dial_code': '1670'
  },
  {
    'id': 'NO',
    'text': 'Norway',
    'dial_code': '47'
  },
  {
    'id': 'OM',
    'text': 'Oman',
    'dial_code': '968'
  },
  {
    'id': 'PK',
    'text': 'Pakistan',
    'dial_code': '92'
  },
  {
    'id': 'PW',
    'text': 'Palau',
    'dial_code': '680'
  },
  {
    'id': 'PA',
    'text': 'Panama',
    'dial_code': '507'
  },
  {
    'id': 'PG',
    'text': 'Papua New Guinea',
    'dial_code': '675'
  },
  {
    'id': 'PY',
    'text': 'Paraguay',
    'dial_code': '595'
  },
  {
    'id': 'PE',
    'text': 'Peru',
    'dial_code': '51'
  },
  {
    'id': 'PH',
    'text': 'Philippines',
    'dial_code': '63'
  },
  {
    'id': 'PL',
    'text': 'Poland',
    'dial_code': '48'
  },
  {
    'id': 'PT',
    'text': 'Portugal',
    'dial_code': '351'
  },
  {
    'id': 'PR',
    'text': 'Puerto Rico',
    'dial_code': '1787'
  },
  {
    'id': 'QA',
    'text': 'Qatar',
    'dial_code': '974'
  },
  {
    'id': 'RO',
    'text': 'Romania',
    'dial_code': '40'
  },
  {
    'id': 'RW',
    'text': 'Rwanda',
    'dial_code': '250'
  },
  {
    'id': 'WS',
    'text': 'Samoa',
    'dial_code': '685'
  },
  {
    'id': 'SM',
    'text': 'San Marino',
    'dial_code': '378'
  },
  {
    'id': 'SA',
    'text': 'Saudi Arabia',
    'dial_code': '966'
  },
  {
    'id': 'SN',
    'text': 'Senegal',
    'dial_code': '221'
  },
  {
    'id': 'RS',
    'text': 'Serbia',
    'dial_code': '381'
  },
  {
    'id': 'SC',
    'text': 'Seychelles',
    'dial_code': '248'
  },
  {
    'id': 'SL',
    'text': 'Sierra Leone',
    'dial_code': '232'
  },
  {
    'id': 'SG',
    'text': 'Singapore',
    'dial_code': '65'
  },
  {
    'id': 'SK',
    'text': 'Slovakia',
    'dial_code': '421'
  },
  {
    'id': 'SI',
    'text': 'Slovenia',
    'dial_code': '386'
  },
  {
    'id': 'SB',
    'text': 'Solomon Islands',
    'dial_code': '677'
  },
  {
    'id': 'ZA',
    'text': 'South Africa',
    'dial_code': '27'
  },
  {
    'id': 'GS',
    'text': 'South Georgia and the South Sandwich Islands',
    'dial_code': '500'
  },
  {
    'id': 'ES',
    'text': 'Spain',
    'dial_code': '34'
  },
  {
    'id': 'LK',
    'text': 'Sri Lanka',
    'dial_code': '94'
  },
  {
    'id': 'SD',
    'text': 'Sudan',
    'dial_code': '249'
  },
  {
    'id': 'SR',
    'text': 'Suriname',
    'dial_code': '597'
  },
  {
    'id': 'SZ',
    'text': 'Swaziland',
    'dial_code': '268'
  },
  {
    'id': 'SE',
    'text': 'Sweden',
    'dial_code': '46'
  },
  {
    'id': 'CH',
    'text': 'Switzerland',
    'dial_code': '41'
  },
  {
    'id': 'TJ',
    'text': 'Tajikistan',
    'dial_code': '992'
  },
  {
    'id': 'TH',
    'text': 'Thailand',
    'dial_code': '66'
  },
  {
    'id': 'TG',
    'text': 'Togo',
    'dial_code': '228'
  },
  {
    'id': 'TK',
    'text': 'Tokelau',
    'dial_code': '690'
  },
  {
    'id': 'TO',
    'text': 'Tonga',
    'dial_code': '676'
  },
  {
    'id': 'TT',
    'text': 'Trinidad and Tobago',
    'dial_code': '1868'
  },
  {
    'id': 'TN',
    'text': 'Tunisia',
    'dial_code': '216'
  },
  {
    'id': 'TR',
    'text': 'Turkey',
    'dial_code': '90'
  },
  {
    'id': 'TM',
    'text': 'Turkmenistan',
    'dial_code': '993'
  },
  {
    'id': 'TC',
    'text': 'Turks and Caicos Islands',
    'dial_code': '1649'
  },
  {
    'id': 'TV',
    'text': 'Tuvalu',
    'dial_code': '688'
  },
  {
    'id': 'UG',
    'text': 'Uganda',
    'dial_code': '256'
  },
  {
    'id': 'UA',
    'text': 'Ukraine',
    'dial_code': '380'
  },
  {
    'id': 'AE',
    'text': 'United Arab Emirates',
    'dial_code': '971'
  },
  {
    'id': 'GB',
    'text': 'United Kingdom',
    'dial_code': '44'
  },
  {
    'id': 'US',
    'text': 'United States Canada',
    'dial_code': '1'
  },
  {
    'id': 'UY',
    'text': 'Uruguay',
    'dial_code': '598'
  },
  {
    'id': 'UZ',
    'text': 'Uzbekistan',
    'dial_code': '998'
  },
  {
    'id': 'VU',
    'text': 'Vanuatu',
    'dial_code': '678'
  },
  {
    'id': 'WF',
    'text': 'Wallis and Futuna',
    'dial_code': '681'
  },
  {
    'id': 'YE',
    'text': 'Yemen',
    'dial_code': '967'
  },
  {
    'id': 'ZM',
    'text': 'Zambia',
    'dial_code': '260'
  },
  {
    'id': 'ZW',
    'text': 'Zimbabwe',
    'dial_code': '263'
  },
  {
    'id': 'BO',
    'text': 'Bolivia Plurinational State of',
    'dial_code': '591'
  },
  {
    'id': 'BN',
    'text': 'Brunei Darussalam',
    'dial_code': '673'
  },
  {
    'id': 'CC',
    'text': 'Cocos Keeling Islands',
    'dial_code': '61'
  },
  {
    'id': 'CD',
    'text': 'Congo The Democratic Republic of',
    'dial_code': '243'
  },
  {
    'id': 'CI',
    'text': 'Cote dIvoire',
    'dial_code': '225'
  },
  {
    'id': 'FK',
    'text': 'Falkland Islands Malvinas',
    'dial_code': '500'
  },
  {
    'id': 'VA',
    'text': 'Holy See Vatican City State',
    'dial_code': '379'
  },
  {
    'id': 'HK',
    'text': 'Hong Kong',
    'dial_code': '852'
  },
  {
    'id': 'IR',
    'text': 'Iran Islamic Republic of',
    'dial_code': '98'
  },
  {
    'id': 'KP',
    'text': 'Korea Democratic Peoples Republic of',
    'dial_code': '850'
  },
  {
    'id': 'KR',
    'text': 'Korea Republic of',
    'dial_code': '82'
  },
  {
    'id': 'LA',
    'text': 'Lao Peoples Democratic Republic',
    'dial_code': '856'
  },
  {
    'id': 'LY',
    'text': 'Libyan Arab Jamahiriya',
    'dial_code': '218'
  },
  {
    'id': 'MO',
    'text': 'Macao',
    'dial_code': '853'
  },
  {
    'id': 'MK',
    'text': 'Macedonia The Former Yugoslav Republic of',
    'dial_code': '389'
  },
  {
    'id': 'FM',
    'text': 'Micronesia Federated States of',
    'dial_code': '691'
  },
  {
    'id': 'MD',
    'text': 'Moldova Republic of',
    'dial_code': '373'
  },
  {
    'id': 'MZ',
    'text': 'Mozambique',
    'dial_code': '258'
  },
  {
    'id': 'PS',
    'text': 'Palestinian Territory Occupied',
    'dial_code': '970'
  },
  {
    'id': 'PN',
    'text': 'Pitcairn',
    'dial_code': '872'
  },
  {
    'id': 'RE',
    'text': 'Réunion',
    'dial_code': '262'
  },
  {
    'id': 'RU',
    'text': 'Russia',
    'dial_code': '7'
  },
  {
    'id': 'BL',
    'text': 'Saint Barthélemy',
    'dial_code': '590'
  },
  {
    'id': 'SH',
    'text': 'Saint Helena Ascension and Tristan Da Cunha',
    'dial_code': '290'
  },
  {
    'id': 'KN',
    'text': 'Saint Kitts and Nevis',
    'dial_code': '1869'
  },
  {
    'id': 'LC',
    'text': 'Saint Lucia',
    'dial_code': '1758'
  },
  {
    'id': 'MF',
    'text': 'Saint Martin',
    'dial_code': '590'
  },
  {
    'id': 'PM',
    'text': 'Saint Pierre and Miquelon',
    'dial_code': '508'
  },
  {
    'id': 'VC',
    'text': 'Saint Vincent and the Grenadines',
    'dial_code': '1784'
  },
  {
    'id': 'ST',
    'text': 'Sao Tome and Principe',
    'dial_code': '239'
  },
  {
    'id': 'SO',
    'text': 'Somalia',
    'dial_code': '252'
  },
  {
    'id': 'SJ',
    'text': 'Svalbard and Jan Mayen',
    'dial_code': '47'
  },
  {
    'id': 'SY',
    'text': 'Syrian Arab Republic',
    'dial_code': '963'
  },
  {
    'id': 'TW',
    'text': 'Taiwan Province of China',
    'dial_code': '886'
  },
  {
    'id': 'TZ',
    'text': 'Tanzania United Republic of',
    'dial_code': '255'
  },
  {
    'id': 'TL',
    'text': 'Timor Leste',
    'dial_code': '670'
  },
  {
    'id': 'VE',
    'text': 'Venezuela Bolivarian Republic of',
    'dial_code': '58'
  },
  {
    'id': 'VN',
    'text': 'Viet Nam',
    'dial_code': '84'
  },
  {
    'id': 'VG',
    'text': 'Virgin Islands British',
    'dial_code': '1284'
  },
  {
    'id': 'VI',
    'text': 'Virgin Islands US',
    'dial_code': '1340'
  },
];
